import checkIsDarkColor from "is-dark-color"
import { theme } from "frontend/src/utils/theme"

function isDarkColor(color) {
  const shortHexColor = color.startsWith("#") ? color : theme.colors[color]
  const length = shortHexColor.length
  let longHexColor
  if (length >= 7) {
    longHexColor = shortHexColor
  } else if (length === 4) {
    const [hash, r, g, b] = shortHexColor.split("")
    longHexColor = [hash, r, r, g, g, b, b].join("")
  }
  return checkIsDarkColor(longHexColor)
}

export { isDarkColor }
